module.exports = __webpack_public_path__ + "components/app-promo/static/icon-app-icon-234f417e98e61df744759d987af1dda6.svg";